import axios from 'axios';
import { OktaAuth } from '@okta/okta-auth-js';

export const fetchSitesData = async () => {
  try {
    const sitesPath = 'v1/user/login/sites';
    if (localStorage.getItem(sitesPath) != null) {
      const { athleteAuthSite, oktaAuth } = JSON.parse(
        localStorage.getItem('v1/user/login/sites') as string,
      );
      return { athleteAuthSite, oktaAuth };
    }
    const response = await axios.get(process.env.REACT_APP_SPONSOR_BASE_URI + sitesPath);
    if (response?.data) {
      localStorage.setItem('v1/user/login/sites', JSON.stringify(response.data));
    }
    const { athleteAuthSite, oktaAuth } = response.data;
    return { athleteAuthSite, oktaAuth };
  } catch (error) {
    return null;
  }
};

export const initializeOktaAuth = async (): Promise<OktaAuth | null> => {
  try {
    const sitesData = await fetchSitesData();
    if (sitesData) {
      return new OktaAuth({
        clientId: 'nike.nde.passplayclient',
        issuer: sitesData.oktaAuth,
        redirectUri: `${window.location.origin}/callback`,
        postLogoutRedirectUri: `${window.location.origin}/login`,
        responseType: ['token', 'id_token'],
        pkce: false,
        tokenManager: {
          storageKey: 'nike.nde.passplayclient',
          storage: 'sessionStorage',
        },
      });
    } else {
      throw new Error('Failed to fetch sites data');
    }
  } catch (error) {
    return null;
  }
};
